export default class RoundedList extends HTMLElement
{

    constructor()
    {
        super();
        this.roundedList = JSON.parse(this.getAttribute('rounded-list'));
        this.stylesheet = this.getAttribute('stylesheet');
    }

    connectedCallback()
    {
        const template = document.querySelector('#rounded-list');
        this._shadowRoot = this.attachShadow({mode: 'open'});
        let instance = template.content.cloneNode(true);
        let roundedListElement;
        let roundedListTemplate = instance.querySelector('[name="rounded-list-element"]');
        instance.querySelector('[name="stylesheet"]').href = this.stylesheet;

        if (this._checkElementExists(this.roundedList) &&
            this._checkElementExists(this.roundedList.title) &&
            this._checkElementExists(this.roundedList.list) &&
            this.roundedList.list.length > 0
        ) {
            instance.querySelector('[name="rounded-list-category-title"]').innerHTML = this.roundedList.title;
            let roundedListContainer = instance.querySelector('[name="rounded-list-container"]');

            this.roundedList.list.forEach((element, index) =>
            {
                roundedListElement = roundedListTemplate.cloneNode(true);
                roundedListElement.querySelector('[name="element-text"]').innerHTML = element.text;
                roundedListElement.querySelector('[name="element-featured-text"]').innerHTML = element.featuredText;
                roundedListContainer.appendChild(roundedListElement)
            });
        }
        roundedListTemplate.remove();

        this._shadowRoot.appendChild(instance);
    }

    _checkElementExists(element)
    {
        if (typeof element !== 'undefined' && element) {
            return true;
        }
        return false;
    }
}
